import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function PublicLayout() {
  const s = useSettings();
  const wa = s.whatsapp_primary || "9513951318";
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <a href={`https://wa.me/91${wa}`} target="_blank" rel="noreferrer"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-transform"
        data-testid="floating-whatsapp" aria-label="WhatsApp">
        <MessageCircle className="w-6 h-6"/>
      </a>
    </div>
  );
}
